module.exports = __webpack_public_path__ + "img/7.36ac1f59.png";